

import _ from 'lodash';

import { type User } from '../../../types/user';
import { types as actionTypes } from './usersActions';
import { type Action } from '../../types';

export type UsersState = {
  usersByLegacyId: { [key: string]: User },
};

const initialState = { usersByLegacyId: {} };

function receiveUsers(state: UsersState, users: User[]): UsersState {
  const usersByLegacyId = _.keyBy(users, 'legacyId');
  return {
    ...state,
    usersByLegacyId,
  };
}

export default function reducer(
  state: UsersState = initialState,
  action: Action<User[]>,
): UsersState {
  switch (action.type) {
    case actionTypes.LOAD_SUCCESS:
      return receiveUsers(state, action.response || []);
    default:
      return state;
  }
}
